import type { TIconElement } from '@shared/dream-components';
import { IconElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TIconElement;
  children: ReactNode | ReactNode[];
}

const Icon = ({ node, children }: Props) => {
  return <IconElement element={node}>{children}</IconElement>;
};

export default Icon;
